// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1351":"4283f1376eae83cf","4266":"05325e2c7260b2b9","6699":"f3e53fcac4730fe0"}[chunkId] + ".css";
};